export enum FileFormat {
	Csv = 'CSV',
	Tdms = 'TDMS',
}
